(function () {
  'use strict';

  function clean(value) {
    return String(value || '').trim();
  }

  function normalize(value) {
    return clean(value).toLowerCase();
  }

  function isColorOption(name) {
    var normalizedName = normalize(name);

    return (
      normalizedName.indexOf('color') !== -1 ||
      normalizedName.indexOf('colour') !== -1
    );
  }

function getLogicalType(row) {
      var customType = clean(
        row.getAttribute('data-qof-type')
      );

      if (customType) {
        return customType;
      }

      var option1Name = clean(
        row.getAttribute('data-option-1-name')
      );

      var option2Name = clean(
        row.getAttribute('data-option-2-name')
      );

      var option1Value = clean(
        row.getAttribute('data-option-1-value')
      );

      var option2Value = clean(
        row.getAttribute('data-option-2-value')
      );

      if (isColorOption(option1Name)) {
        return '';
      }

      if (
        option2Value &&
        normalize(option2Name).indexOf('type') !== -1
      ) {
        return option2Value;
      }

      return option1Value;
    }
  function getLogicalColor(row) {
        var customColor = clean(
          row.getAttribute('data-qof-color')
        );

        if (customColor) {
          return customColor;
        }

        var option1Name = clean(
          row.getAttribute('data-option-1-name')
        );

        var option2Name = clean(
          row.getAttribute('data-option-2-name')
        );

        var option1Value = clean(
          row.getAttribute('data-option-1-value')
        );

        var option2Value = clean(
          row.getAttribute('data-option-2-value')
        );

        if (isColorOption(option1Name)) {
          return option1Value;
        }

        if (isColorOption(option2Name)) {
          return option2Value;
        }

        return option2Value;
      }

  function getVariantRows() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '#Quick-order-form .wsaio_qof-product-row.variant-row'
      )
    );
  }

  function getVariantRowsForCurrentCollection() {
    var allRows = getVariantRows();

    var collectionFilter = document.getElementById(
      'wsaio_qof-filter-dropdown'
    );

    if (!collectionFilter || !collectionFilter.value) {
      return allRows;
    }

    var selectedCollection = normalize(
      collectionFilter.value
    );

    var matchingRows = allRows.filter(function (variantRow) {
      var parentId =
        variantRow.getAttribute('data-parent-id');

      var productRow = document.querySelector(
        '#Quick-order-form .product_data[data-product-id="' +
          parentId +
        '"]'
      );

      if (!productRow) {
        return false;
      }

      var productCollections = String(
        productRow.getAttribute('data-tags') || ''
      )
        .split(',')
        .map(function (handle) {
          return normalize(handle);
        });

      return (
        productCollections.indexOf(selectedCollection) !== -1
      );
    });

    return matchingRows.length ? matchingRows : allRows;
  }

  function getProductRows() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '#Quick-order-form .wsaio_qof-product-row.product_data'
      )
    );
  }

  function populateLogicalSelect(
    select,
    rows,
    valueGetter,
    title
  ) {
    if (!select) {
      return;
    }

    var previousValue = select.value;
    var values = {};

    rows.forEach(function (row) {
      var value = clean(valueGetter(row));

      if (value) {
        values[normalize(value)] = value;
      }
    });

    select.innerHTML = '';

    var allOption = document.createElement('option');
    allOption.value = '';
    allOption.textContent = 'All ' + title;
    select.appendChild(allOption);

    Object.keys(values)
      .map(function (key) {
        return values[key];
      })
      .sort(function (a, b) {
        return a.localeCompare(b, undefined, {
          numeric: true,
          sensitivity: 'base'
        });
      })
      .forEach(function (value) {
        var option = document.createElement('option');

        option.value = value;
        option.textContent = value;

        select.appendChild(option);
      });

    var previousStillExists =
      Array.prototype.some.call(
        select.options,
        function (option) {
          return (
            normalize(option.value) ===
            normalize(previousValue)
          );
        }
      );

    if (previousStillExists) {
      select.value = previousValue;
    }
  }

  function buildFilters() {
      var filter1 = document.getElementById(
        'qof-option-1-filter'
      );

      var filter2 = document.getElementById(
        'qof-option-2-filter'
      );

      var variantRows =
        getVariantRowsForCurrentCollection();

      var productRows = getProductRows();

      if (!filter1 || !filter2) {
        return false;
      }

      var logicalRows = variantRows.slice();

      /*
      * Add products that have no separate variant rows.
      * This includes closet Shopify Bundles with one default variant.
      */
      productRows.forEach(function (productRow) {
        var productId =
          productRow.getAttribute('data-product-id');

        var hasVariantRows = document.querySelector(
          '#Quick-order-form .variant-row[data-parent-id="' +
            productId +
          '"]'
        );

        if (!hasVariantRows) {
          logicalRows.push(productRow);
        }
      });

      if (logicalRows.length === 0) {
        return false;
      }

      populateLogicalSelect(
        filter1,
        logicalRows,
        getLogicalType,
        'Type'
      );

      populateLogicalSelect(
        filter2,
        logicalRows,
        getLogicalColor,
        'Color'
      );

      return true;
    }

  function applyFilters() {
    var filter1 = document.getElementById(
      'qof-option-1-filter'
    );

    var filter2 = document.getElementById(
      'qof-option-2-filter'
    );

    if (!filter1 || !filter2) {
      return;
    }

    var selectedType = normalize(filter1.value);
    var selectedColor = normalize(filter2.value);

    var filtersActive =
      selectedType !== '' || selectedColor !== '';

    var matchingProductIds = {};

    getVariantRows().forEach(function (row) {
      var logicalType = normalize(
        getLogicalType(row)
      );

      var logicalColor = normalize(
        getLogicalColor(row)
      );

      var matchesType =
        !selectedType || logicalType === selectedType;

      var matchesColor =
        !selectedColor || logicalColor === selectedColor;

      var matches = matchesType && matchesColor;

      var parentId =
        row.getAttribute('data-parent-id');

      if (matches && parentId) {
        matchingProductIds[parentId] = true;
      }

      if (filtersActive) {
        row.style.display = matches ? '' : 'none';
      } else {
        row.style.display = 'none';
      }
    });

    getProductRows().forEach(function (productRow) {
      var productId =
        productRow.getAttribute('data-product-id');

      var hasVariantRows = document.querySelector(
        '#Quick-order-form .variant-row[data-parent-id="' +
          productId +
        '"]'
      );

      /*
      * Products with variant rows use the variant matches.
      */
      if (hasVariantRows) {
        productRow.style.display =
          !filtersActive || matchingProductIds[productId]
            ? ''
            : 'none';

        return;
      }

      /*
      * No-variant Shopify Bundle:
      * filter directly from product metafields.
      */
      var logicalType = normalize(
        getLogicalType(productRow)
      );

      var logicalColor = normalize(
        getLogicalColor(productRow)
      );

      var matchesType =
        !selectedType || logicalType === selectedType;

      var matchesColor =
        !selectedColor || logicalColor === selectedColor;

      productRow.style.display =
        !filtersActive || (matchesType && matchesColor)
          ? ''
          : 'none';
    });

    var resetButton = document.getElementById(
      'wsaio_qof-reset-filters'
    );

    if (resetButton) {
      resetButton.style.visibility =
        filtersActive ? 'visible' : 'hidden';
    }
  }

  function attachEvents() {
    var filter1 = document.getElementById(
      'qof-option-1-filter'
    );

    var filter2 = document.getElementById(
      'qof-option-2-filter'
    );

    var resetButton = document.getElementById(
      'wsaio_qof-reset-filters'
    );

    if (
      filter1 &&
      filter1.dataset.variantFilterReady !== 'true'
    ) {
      filter1.dataset.variantFilterReady = 'true';
      filter1.addEventListener('change', applyFilters);
    }

    if (
      filter2 &&
      filter2.dataset.variantFilterReady !== 'true'
    ) {
      filter2.dataset.variantFilterReady = 'true';
      filter2.addEventListener('change', applyFilters);
    }

    if (
      resetButton &&
      resetButton.dataset.variantResetReady !== 'true'
    ) {
      resetButton.dataset.variantResetReady = 'true';

      resetButton.addEventListener('click', function () {
        if (filter1) {
          filter1.value = '';
        }

        if (filter2) {
          filter2.value = '';
        }

        applyFilters();
      });
    }
  }

  function initialize() {
    var attempts = 0;

    var timer = window.setInterval(function () {
      attempts += 1;

      if (buildFilters()) {
        attachEvents();
        window.clearInterval(timer);
      }

      if (attempts >= 100) {
        window.clearInterval(timer);
      }
    }, 300);

    var collectionFilter = document.getElementById(
      'wsaio_qof-filter-dropdown'
    );

    if (
      collectionFilter &&
      collectionFilter.dataset.variantRebuildReady !==
        'true'
    ) {
      collectionFilter.dataset.variantRebuildReady =
        'true';

      collectionFilter.addEventListener(
        'change',
        function () {
          window.setTimeout(function () {
            buildFilters();
            attachEvents();
          }, 500);
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }
})();